module.exports = __webpack_public_path__ + "img/Ic_Subbase-installation.d463aea6.svg";